/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BannerUpdateRequest = {
    bootCampCategory?: BannerUpdateRequest.bootCampCategory;
    type?: BannerUpdateRequest.type;
    title?: string;
    sequence?: number;
    forwardLink?: string;
    displayStartAt?: string;
    displayEndAt?: string;
    hide?: boolean;
    id?: number;
};

export namespace BannerUpdateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }

    export enum type {
        HERO = 'HERO',
        POPUP = 'POPUP',
    }


}

